import { createAppFromCommonTemplate, lazyImport } from '@helpers'

const { FaqListing } = lazyImport(
  () => import('@components/FaqListing/FaqListing'),
  'FaqListing',
)

export const renderFaqListingApp = (
  faqListingEl: HTMLElement | null,
  faqData: any,
) => {
  createAppFromCommonTemplate(faqListingEl, <FaqListing faqData={faqData} />)
}
